import React from 'react';

import { VerticalTimelineItem } from '../../../components/VerticalTimelineItem';
import './style.scss';
import { AuditChange } from './AuditChange';
import { AuditType } from 'app/types/User';

type Props = {
  audit: AuditType;
  lastItem: boolean;
};

export const AuditCard = ({ audit, lastItem }: Props) => {
  return (
    <VerticalTimelineItem audit={audit} lastItem={lastItem}>
      <div className="audit-card">
        <div className="audit-card-header">
          <div>
            <p>Key: {audit?.key}</p>
          </div>
          <div>
            <p>Action: {audit?.action}</p>
          </div>
          <div>
            <p>by: {audit?.creator?.key}</p>
          </div>
        </div>
        <div className="audit-card-body">
          <h4>
            <span>changes</span>
          </h4>
          <div className="audit-changes">
            {audit?.data &&
              Object.keys(audit.data).map((field) => (
                <AuditChange field={field} changes={audit.data!} />
              ))}
          </div>
        </div>
      </div>
    </VerticalTimelineItem>
  );
};
